module.exports = __webpack_public_path__ + "static/media/leal_logo_round_small.8f51cd64.svg";